import styled, { css } from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import breakpoint from "styled-components-breakpoint"
import { lighten } from "polished"

export const TickIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.success};
  height: 1rem;
  width: 1rem;
  margin-left: 0.5rem;
`

export const StyledTabbedForm = styled.div``
export const Nav = styled.nav`
  gap: 32px;
  display: none;
  ${breakpoint("tablet")`
    display: flex;
  `}
`

export const NavItem = styled.div``

export const NavButton = styled.button`
  color: #666666;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ selected }) =>
    !!selected &&
    css`
      color: #333333;
    `}

  ${({ disabled }) =>
    !!disabled &&
    css`
      color: #999999;
    `}
`

export const NavItemSelected = styled.div`
  height: 4px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 99px;
  margin: 10px 0 0;
`
export const TabSection = styled.div`
  color: black;
`
export const TabSections = styled.div`
  color: black;
`

// Mobile dropdown styles
export const MobileDropdownWrapper = styled.div`
  display: none;
  position: relative;

  ${breakpoint("tablet", "max")`
    display: block;
    margin-bottom: 16px;
  `}
`

export const MobileDropdownSelected = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`

export const MobileDropdownList = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
  max-height: 240px;
  overflow-y: auto;
`

export const MobileDropdownOption = styled.div`
  padding: 12px 16px;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    background: #f0f8ff;
  }
  &.selected {
    background: #e6f4fa;
    font-weight: 600;
  }
`

// Show mobile dropdown only on mobile
export const TabbedFormMobileDropdownWrapper = styled.div`
  display: none;
  ${breakpoint("tablet", "max")`
    display: block;
  `}
`

// Mobile native select styles
export const MobileSelectWrapper = styled.div`
  display: none;
  ${breakpoint("tablet", "max")`
    display: block;
    width: 100%;
    margin-bottom: 16px;
    position: relative;
  `}
`

export const MobileSelect = styled.select`
  width: 100%;
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  background: transparent;
  border: none;
  border-radius: 0;
  outline: none;
  padding: 0 0 8px 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  position: relative;
  z-index: 2;
  box-shadow: none;
  ${breakpoint("desktop")`
    display: none;
  `}

  /* Hide default arrow in some browsers */
  &::-ms-expand {
    display: none;
  }
`

export const MobileSelectUnderline = styled.div`
  width: 100%;
  height: 4px;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 99px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  ${breakpoint("desktop")`
    display: none;
  `}
`

export const Count = styled.div`
  background: ${({ theme }) => lighten(0.8, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 99px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
`
